import { Chess } from 'chess.js';

window.Chess = Chess;
